import Compress from 'compress.js'
import Logger from 'services/Logger'

export async function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result as string)
    reader.onerror = reject
    reader.readAsDataURL(file)
  })
}

export function base64RemoveMetadata(string: string): string {
  const parts = string.split(',')

  if (parts.length < 2) {
    return string
  }

  return string.split(',')[1]
}

const compress = new Compress()

const maxImageSize = 1024

export async function compressBase64(base64: string) {
  try {
    // Fetch the image data from base64
    const fetchResponse = await fetch(base64)
    const blob = await fetchResponse.blob()

    // Convert blob to File
    const fileName = 'image.jpg'
    const mimeType = blob.type
    const file = new File([blob], fileName, { type: mimeType })

    Logger.blue('Compress:InitialSize', file.size)

    // Compress the file
    const compressedData = await compress.compress([file], {
      size: 1, // the max size in MB, defaults to 2MB
      quality: base64.includes('jpeg') || base64.includes('jpg') ? 0.9 : 1,
      maxWidth: maxImageSize,
      maxHeight: maxImageSize,
      resize: true
    })

    Logger.blue('Compress:CompressedSize', compressedData)

    // In newer versions of compress.js, the data format may have changed
    // Check if data is the expected base64 string
    if (typeof compressedData[0].data === 'string') {
      return compressedData[0].data
    }

    // If it's a Blob or File object, convert it to base64
    if (
      compressedData[0].data instanceof Blob ||
      compressedData[0].data instanceof File
    ) {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.readAsDataURL(compressedData[0].data)
      })
    }

    // If it's in a different format, try to handle it
    if (compressedData[0].prefix && compressedData[0].data) {
      // Some versions return {prefix, data} format
      return `${compressedData[0].prefix},${compressedData[0].data}`
    }

    console.error('Unexpected format from compress.js:', compressedData[0])
    throw new Error('Compress.js returned unexpected data format')
  } catch (error) {
    console.error('Error in compressBase64:', error)
    // Return original base64 as fallback
    return base64
  }
}

export const handleSaveToPC = (contactsData: any, fileName?: string) => {
  const fileData = JSON.stringify(contactsData)
  const blob = new Blob([fileData], { type: 'text/plain' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.download = `${fileName ?? 'filename'}.json`
  link.href = url
  link.click()
}

export function getStringSizeInKB(str: string): number {
  const blob = new Blob([str], { type: 'text/plain' })
  return blob.size / 1024
}

export function convertBytesToMB(bytes?: number): number {
  if (!bytes) return 0

  // round to 4 signs
  return Math.round((bytes / 1024 / 1024) * 10000) / 10000
}
